module.exports = __webpack_public_path__ + "static/media/crown_118.b7983412.png";